import * as React from 'react';
import { VARIANTS } from "@ui-seeker/core"

import { THEME_MODE, COLORS, COLOR_TONES } from "../../../@constants"
import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from './@CustomIcons';


const overrideAlertStyles = (theme) => {
  const isLight = theme.palette.mode === THEME_MODE.LIGHT

  const rootStyle = ownerState => {
    const standardVariant = ownerState.variant === VARIANTS.STANDARD
    const filledVariant = ownerState.variant === VARIANTS.FILLED
    const outlinedVariant = ownerState.variant === VARIANTS.OUTLINED

    const colorStyle = Object.values(COLORS).map(color => ({
      ...(ownerState.severity === color && {
        // STANDARD
        ...(standardVariant && {
          color: theme.palette[color][isLight ? COLOR_TONES.DARKER : COLOR_TONES.LIGHTER],
          backgroundColor: theme.palette[color][isLight ? COLOR_TONES.LIGHTER : COLOR_TONES.DARKER],
          '& .MuiAlert-icon': {
            color: theme.palette[color][isLight ? COLOR_TONES.MAIN : COLOR_TONES.LIGHT]
          }
        }),
        // FILLED
        ...(filledVariant && {
          color: theme.palette[color].contrastText,
          backgroundColor: theme.palette[color].main
        }),
        // OUTLINED
        ...(outlinedVariant && {
          color: theme.palette[color][isLight ? COLOR_TONES.DARK : COLOR_TONES.LIGHT],
          border: `solid 1px ${theme.palette[color].main}`,
          '& .MuiAlert-icon': {
            color: theme.palette[color].main
          }
        })
      })
    }))

    return [...colorStyle]
  }

  return {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          info: <InfoIcon />,
          success: <SuccessIcon />,
          warning: <WarningIcon />,
          error: <ErrorIcon />
        }
      },

      styleOverrides: {
        root: ({ ownerState }) => rootStyle(ownerState),
        icon: {
          opacity: 1,
          alignItems: 'center'
        }
      }
    },
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          marginBottom: theme.spacing(0.5)
        }
      }
    }
  }
}

export default overrideAlertStyles
